import * as math from 'mathjs'

export const isNullOrUndefined = (v: any): boolean => {
  return v === undefined || v === 'undefined' || v === null || v === 'null'
}

export function numberWithCommas(number: number | string) {
  const regex = /\B(?=(\d{3})+(?!\d))/g
  return number.toString().replace(regex, ',')
}

export const toCurrency = (amount: string, digits: number = 2): string => {
  if (isNullOrUndefined(amount)) {
    return '-'
  }

  const normalizeNumber = (value: string): string => {
    const trimmed = value.trim()
    if (!trimmed) return '0'

    const scientific = trimmed.match(/^([+-]?)(\d+)(?:\.(\d+))?[eE]([+-]?\d+)$/)
    if (!scientific) return trimmed

    const [, sign, intPart, fracPart = '', exponentRaw] = scientific
    const digitsOnly = `${intPart}${fracPart}`.replace(/^0+/, '') || '0'
    const decimalIndex = intPart.length
    const exponent = parseInt(exponentRaw, 10)
    const newDecimalIndex = decimalIndex + exponent

    let normalized = ''
    if (newDecimalIndex <= 0) {
      normalized = `0.${'0'.repeat(Math.abs(newDecimalIndex))}${digitsOnly}`
    } else if (newDecimalIndex >= digitsOnly.length) {
      normalized = `${digitsOnly}${'0'.repeat(newDecimalIndex - digitsOnly.length)}`
    } else {
      normalized = `${digitsOnly.slice(0, newDecimalIndex)}.${digitsOnly.slice(newDecimalIndex)}`
    }

    return sign === '-' && normalized !== '0' ? `-${normalized}` : normalized
  }

  const raw = normalizeNumber(amount.toString())
  const matchResult = raw.match(/^(-?)(\d+)(?:\.(\d+))?$/)
  if (!matchResult) {
    return `0.${'0'.repeat(digits)}`
  }

  const [, sign, intPart, fracPart = ''] = matchResult
  const integer = `${sign}${intPart}`
  const decimal = fracPart.slice(0, digits)

  return `${numberWithCommas(integer)}.${decimal.padEnd(digits, '0')}`
}

export const getBignumber = (value: any) => {
  return math.bignumber(value || 0) // Convert value to 0 if it is an empty string
}

export const getExchangeRate = (numerator?: string, denominator?: string, digits = 2) => {
  const scale = Math.pow(10, digits)
  return Math.round((Number(numerator) / Number(denominator) + Number.EPSILON) * scale) / scale
}
